<div class="print-configurations" [formGroup]="form">
	<mat-label class="mat-body-1 element-section-label">
		{{ 'mes.administration.print-configuration.label' | translate }}
	</mat-label>
	<div class="print-configurations-list" formArrayName="printConfigurations" cdkDropList (cdkDropListDropped)="onDrop($event)">
		@for (config of printConfigurations.controls; track config; let i = $index) {
			<div #dragRow class="drag-row" [class.is-expanded]="expandedIndex === i" cdkDrag cdkDragLockAxis="y">
				@if (config.invalid && isGroupTouched(config)) {
					<span class="row-error-hint">
						{{ 'mes.administration.print-configuration.row-has-errors' | translate }}
					</span>
				}
				<div class="drag-row-summary">
					<mat-form-field appearance="fill" class="flex-fill" [class.row-has-error]="config.invalid && isGroupTouched(config)">
						<mat-icon matPrefix cdkDragHandle class="drag-icon">reorder</mat-icon>
						<input matInput readonly [value]="getRowLabel(config)" class="row-label-input" />
						<span matSuffix class="row-actions">
							<button mat-icon-button type="button" [color]="expandedIndex === i ? 'primary' : config.invalid && isGroupTouched(config) ? 'warn' : ''" (click)="toggleExpand(i)">
								<mat-icon svgIcon="acies_edit"></mat-icon>
							</button>
							<button mat-icon-button type="button" (click)="deletePrintConfiguration(i)">
								<mat-icon svgIcon="acies_delete"></mat-icon>
							</button>
						</span>
					</mat-form-field>
				</div>
				@if (expandedIndex === i) {
					<div @expandCollapse class="expanded-panel" [formGroupName]="i" (@expandCollapse.done)="focusAliasInput(dragRow)">
						<div class="expanded-panel-row">
							<mat-form-field appearance="outline">
								<mat-label>
									{{ 'mes.administration.print-configuration.alias.label' | translate }}
								</mat-label>
								<input #aliasInput [id]="'aliasInput_' + i" matInput formControlName="alias" maxlength="255" />
								@if (shouldShowError(config.get('alias'))) {
									<mat-error>
										{{ 'mes.administration.print-configuration.alias.error.' + getFirstValidationErrorName(config, 'alias') | translate: getValidationErrorParams(config, 'alias') }}
									</mat-error>
								}
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>
									{{ 'mes.administration.print-configuration.description.label' | translate }}
								</mat-label>
								<input matInput formControlName="description" maxlength="255" />
								@if (shouldShowError(config.get('description'))) {
									<mat-error>
										{{ 'mes.administration.print-configuration.description.error.' + getFirstValidationErrorName(config, 'description') | translate: getValidationErrorParams(config, 'description') }}
									</mat-error>
								}
							</mat-form-field>
						</div>
						<div class="expanded-panel-row">
							<mat-form-field appearance="outline">
								<mat-label>
									{{ 'mes.administration.print-configuration.dataSource.label' | translate }}
								</mat-label>
								<mat-select #dataSourceSelect formControlName="dataSource">
									<mat-option value="Group">
										{{ 'mes.administration.print-configuration.dataSource.group' | translate }}
									</mat-option>
									<mat-option value="Item">
										{{ 'mes.administration.print-configuration.dataSource.item' | translate }}
									</mat-option>
								</mat-select>
								@if (shouldShowError(config.get('dataSource'))) {
									<mat-error>
										{{ 'mes.administration.print-configuration.dataSource.error.' + getFirstValidationErrorName(config, 'dataSource') | translate }}
									</mat-error>
								}
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>
									{{ 'mes.administration.print-configuration.stationNo.label' | translate }}
								</mat-label>
								<mat-select formControlName="stationNo" [compareWith]="compareStationNo">
									<mat-option [value]="0">
										{{ 'mes.administration.print-configuration.all-stations' | translate }}
									</mat-option>
									@for (s of stationOptions; track s) {
										<mat-option [value]="s.value">{{ s.label }}</mat-option>
									}
								</mat-select>
							</mat-form-field>
							<div class="autoPrint-checkbox-field">
								<mat-checkbox formControlName="autoPrint">
									{{ 'mes.administration.print-configuration.autoPrint.label' | translate }}
								</mat-checkbox>
							</div>
						</div>
						<div class="expanded-panel-row">
							<mat-form-field appearance="outline">
								<mat-label>
									{{ 'mes.administration.print-configuration.printerId.label' | translate }}
								</mat-label>
								<mat-select formControlName="printer">
									@for (p of printerOptions; track p) {
										<mat-option [value]="p.id">{{ p.name }}</mat-option>
									}
								</mat-select>
								@if (shouldShowError(config.get('printer'))) {
									<mat-error>
										{{ 'mes.administration.print-configuration.printerId.error.' + getFirstValidationErrorName(config, 'printer') | translate }}
									</mat-error>
								}
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>
									{{ 'mes.administration.print-configuration.templateId.label' | translate }}
								</mat-label>
								<mat-select formControlName="template">
									@for (t of templateOptions; track t) {
										<mat-option [value]="t.id">{{ t.name }}</mat-option>
									}
								</mat-select>
								@if (shouldShowError(config.get('template'))) {
									<mat-error>
										{{ 'mes.administration.print-configuration.templateId.error.' + getFirstValidationErrorName(config, 'template') | translate }}
									</mat-error>
								}
							</mat-form-field>
						</div>
					</div>
				}
			</div>
		}
	</div>
	<div class="add-row" [formGroup]="addRowForm">
		<mat-form-field appearance="outline" class="add-row-alias">
			<mat-label>
				{{ 'mes.administration.print-configuration.alias.label' | translate }}
			</mat-label>
			<input matInput formControlName="alias" maxlength="255" />
			@if (shouldShowError(addRowForm.get('alias'))) {
				<mat-error>
					{{ 'mes.administration.print-configuration.alias.error.' + getFirstValidationErrorName(addRowForm, 'alias') | translate: getValidationErrorParams(addRowForm, 'alias') }}
				</mat-error>
			}
		</mat-form-field>

		<mat-form-field appearance="outline" class="add-row-description">
			<mat-label>
				{{ 'mes.administration.print-configuration.description.label' | translate }}
			</mat-label>
			<input matInput formControlName="description" maxlength="255" />
			@if (shouldShowError(addRowForm.get('description'))) {
				<mat-error>
					{{ 'mes.administration.print-configuration.description.error.' + getFirstValidationErrorName(addRowForm, 'description') | translate: getValidationErrorParams(addRowForm, 'description') }}
				</mat-error>
			}
		</mat-form-field>

		<button mat-icon-button type="button" [disabled]="addRowForm.invalid" (click)="confirmAddRow()">
			<mat-icon svgIcon="acies_add_alt"></mat-icon>
		</button>
	</div>
</div>
